import z from 'zod';

export const eContractStatusEnumSchema = z.enum([
  'document.draft',
  'document.sent',
  'document.completed',
  'document.uploaded',
  'document.error',
  'document.viewed',
  'document.waiting_approval',
  'document.approved',
  'document.rejected',
  'document.waiting_pay',
  'document.paid',
  'document.voided',
  'document.declined',
  'document.external_review',
]);

export type eContractStatusEnum = z.infer<typeof eContractStatusEnumSchema>;
